import { c as _c } from "react/compiler-runtime";
import api from "@/actions/api";
import { QueryKeys } from "@/constants/queryKeys";
import { useQuery } from "@tanstack/react-query";
export default function useRealEstateGroups(realEstateId) {
  const $ = _c(2);
  let t0;
  if ($[0] !== realEstateId) {
    t0 = {
      queryKey: [QueryKeys.ESTATE_FAV_GROUPS, realEstateId],
      queryFn: () => api.favoriteGroups.getRealEstateGroups(realEstateId)
    };
    $[0] = realEstateId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useQuery(t0);
}